import { usePriceImpact } from '@capsicum/common';
import { type ComponentProps } from 'react';
import styled, { css } from 'styled-components';

import { BoldText, Text } from '../../atoms';

type PriceImpactProps = Omit<ComponentProps<typeof S.StyledText>, 'children'> & {
	amount?: string;
};

export const PriceImpact = ({ amount, ...props }: PriceImpactProps) => {
	const { label, variant } = usePriceImpact({ amount, Bold: BoldText });

	return !amount ? null : (
		<S.StyledText $variant={variant} {...props}>
			{label}
		</S.StyledText>
	);
};

namespace S {
	export const StyledText = styled(Text)<{ $variant?: 'destructive' | 'warning' }>`
		${({ $variant }) =>
			$variant &&
			css`
				color: ${({ theme }) => theme.colors.text[$variant].enabled};
			`}
	`;
}
